import SyCalendar from "./sy-calendar";

export default SyCalendar;